$(document).ready(function(){$(".bannerslide").owlCarousel({loop:!0,dots:!0,margin:0,autoplay:!0,autoplayTimeout:7e3,slideSpeed:100,animateOut:"fadeOut",responsiveClass:!0,autoplayHoverPause:!0,smartSpeed:1500,nav:!1,responsive:{0:{items:1,nav:!1},600:{items:1,nav:!1},1e3:{items:1,loop:!0,nav:!1}}})});
//# sourceMappingURL=/s/files/1/0634/3268/7771/files/custom.js.map?v=1724180327
$(document).ready(function() {
    $('ul.tabs').each(function(){
      var active, content, links = $(this).find('a');
      active = links.first().addClass('active');
      content = $(active.attr('href'));
      links.not(':first').each(function () {
        $($(this).attr('href')).hide();
      });
      $(this).find('a').click(function(e){
        active.removeClass('active');
        content.hide();
        active = $(this);
        content = $($(this).attr('href'));
        active.addClass('active');
        content.show();
        return false;
      });
    });
  });